import React, { useState, useEffect } from 'react';
import cn from 'classnames';

import { Button, Icon, Alert } from 'components/common/Elements/Elements';

import { subscribe } from 'utils/notification';

import classes from './Notification.module.scss';

export function Notification() {
  const [content, setContent] = useState([]);
  useEffect(() => subscribe(setContent), []);

  const handleClose = (id, close) => () => {
    close(id);
  };

  return (
    <div className={classes.wrap}>
      {content.map(notif => {
        if (notif.type === 'alert') {
          return (
            <div className={classes.container} key={notif.id}>
              <Alert id={notif.id} message={notif.message} kind={notif.kind} />
            </div>
          );
        } else {
          return (
            <div
              className={cn(
                classes.info,
                notif.kind === 'error' && classes.error,
                notif.kind === 'success' && classes.success
              )}
              key={notif.id}
            >
              {notif.component}
              <Button
                className={classes.clear}
                onClick={handleClose(notif.id, notif.onClose)}
                title="close alert"
              >
                <Icon icon={'close'} className={classes.icon} size="16px" />
              </Button>
            </div>
          );
        }
      })}
    </div>
  );
}
